// REMOVE ALL DEFAULT INSTANT ADD TO CART FUNCTIONALITY
(function() {
  const SELECTOR = '[data-instant-action-type="add-to-instant-cart"]';
  const EV = (window.FGSECOMAPP && window.FGSECOMAPP.CUSTOM_EVENTS) || {
    START_PROCESS_CART: 'fg-cart:start-process', END_PROCESS_CART: 'fg-cart:end-process',
    CART_AUTO_UPDATED: 'fg-cart:auto-updated', GIFT_ADDED: 'fg-gifts:added',
    GIFT_UPDATED: 'fg-gifts:updated', BOGOS_GIFT_OFFER_CHECK: 'bogos:gift-check',
};

function neutralize(el) {
    el.dataset.customPatched || (el.dataset.customPatched = "true", el.removeAttribute("href"));
}

document.querySelectorAll(SELECTOR).forEach(neutralize);

new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type === 'attributes' && m.target.matches?.(SELECTOR)) m.target.removeAttribute('href');
      m.addedNodes.forEach((node) => {
        node.nodeType === 1 && (
          node.matches?.(SELECTOR) && neutralize(node),
          node.querySelectorAll?.(SELECTOR).forEach(neutralize)
        );
      });
    }
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

// --- cart drawer loader helpers ---
// data-instant-type="overlay" is stable across rebuilds, unlike the hashed
// class names. Multiple overlays can exist on a page (quick-view, etc.), so
// identify the cart one by its content rather than assuming there's only one.
function getCartOverlayEl() {
    const overlays = Array.from(document.querySelectorAll('[data-instant-type="overlay"]'));
    return overlays.find(el => el.textContent.includes('Your Cart') || el.textContent.includes('Continue Shopping')) || null;
}
function showCartLoader() {
    const loader = document.querySelector('.cart_loader');
    if (loader) loader.classList.remove('cart-not-loading');
}
function hideCartLoader() {
    const loader = document.querySelector('.cart_loader');
    if (loader) loader.classList.add('cart-not-loading');
}

  // --- add to cart + wait for gifting (event-driven, cart-diff confirmed) ---
async function addToCartAndWaitForGifting(variantId, quantity = 1, opts = {}) {
    const settleMs = opts.settleMs ?? 1500, timeoutMs = opts.timeoutMs ?? 8000;
    const beforeCart = await fetch('/cart.js').then(r => r.json());
    const beforeVariantIds = new Set(beforeCart.items.map(i => i.variant_id));
    const activity = { events: [] };
    let settleTimer, hardTimer, cleanedUp = false;
    const names = [EV.START_PROCESS_CART, EV.END_PROCESS_CART, EV.CART_AUTO_UPDATED, EV.GIFT_ADDED, EV.GIFT_UPDATED, EV.BOGOS_GIFT_OFFER_CHECK];
    const done = new Promise((resolve) => {
        const arm = () => { clearTimeout(settleTimer); settleTimer = setTimeout(() => finish('quiet'), settleMs); };
        const record = (name) => () => { activity.events.push({ name, ts: Date.now() }); arm(); };
        const listeners = names.map(n => { const fn = record(n); document.addEventListener(n, fn); return [n, fn]; });
    
        function finish(reason) {
            if (cleanedUp) return; cleanedUp = true;
            clearTimeout(settleTimer); clearTimeout(hardTimer);
            listeners.forEach(([n, fn]) => document.removeEventListener(n, fn));
            resolve(reason);
        }
    hardTimer = setTimeout(() => finish('timeout'), timeoutMs);
    arm();
});

    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity }) });
    if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || `Add to cart failed: ${res.status}`); }
    const settleReason = await done;
    const afterCart = await fetch('/cart.js').then(r => r.json());
    const newItems = afterCart.items.filter(i => !beforeVariantIds.has(i.variant_id));
    const gifts = newItems.filter(i => i.properties?._bogos_trigger_type === 'gift');
    return { settleReason, events: activity.events, gifts, cart: afterCart };
}

document.addEventListener("click", async function(e) {
    const target = e.target.closest(SELECTOR);
    if (!target) return;
    e.preventDefault(), e.stopImmediatePropagation();
    const variantId = target.getAttribute("data-instant-action-variant-id"),
    productId = target.getAttribute("data-instant-action-id");
    console.log(`Instant add to cart button clicked : ${productId}`);

    // open the drawer immediately, before the network call even starts
    window.Instant.api.toggleCart(true);
    showCartLoader();
    try {
        await addToCartAndWaitForGifting(variantId, 1);
    } catch (err) {
        console.error('Instant add to cart failed:', err);
        // decide your own error state here — e.g. swap the loader text to
        // "Something went wrong" instead of just hiding it
    } finally {
        hideCartLoader();
        window.Instant.api.updateCart(); // syncs drawer with actual cart, success or not
    }
    }, true);
})();


// Neutralize Instant's own native "adjust-line-item-quantity" dispatcher —
// same pattern as the href-strip for add-to-cart. Their core library reads
// data-instant-action-type globally and runs its own built-in handling for
// recognized values; stripping the attribute means their dispatcher no
// longer matches these buttons at all, so only our logic runs.
function neutralizeAdjustQty(el) {
  if (el.dataset.qtyPatched) return;
  el.dataset.qtyPatched = 'true';
  el.removeAttribute('data-instant-action-type');
}
document.querySelectorAll('[data-instant-action-type="adjust-line-item-quantity"]').forEach(neutralizeAdjustQty);
new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (m.type === 'attributes' && m.target.getAttribute?.('data-instant-action-type') === 'adjust-line-item-quantity') {
      neutralizeAdjustQty(m.target);
    }
    if (m.type === 'childList') {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('[data-instant-action-type="adjust-line-item-quantity"]')) neutralizeAdjustQty(node);
        node.querySelectorAll?.('[data-instant-action-type="adjust-line-item-quantity"]').forEach(neutralizeAdjustQty);
      });
    }
  }
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-instant-action-type'] });

// Remove line item, with the .line-item-updating class as the loading signal
document.addEventListener('click', async function(e) {
  const btn = e.target.closest('.remove_lineItem_btn');
  if (!btn) return;

  // the inner action button carries the line item key directly — more
  // direct than climbing to the row, kept as a fallback in case markup shifts
  const innerBtn = btn.querySelector('[data-instant-action-line-item-key]');
  const row = btn.closest('[data-instant-repeater-type="CART_ITEMS"]');
  const lineItemKey = innerBtn?.getAttribute('data-instant-action-line-item-key') || row?.getAttribute('data-instant-form-line-item-key');
  if (!lineItemKey) return;

  const targetRow = row || btn;
  targetRow.classList.add('line-item-updating');
  btn.style.pointerEvents = 'none';

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: 0 }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || `Remove failed: ${res.status}`);
    }
    await window.Instant.api.updateCart();
  } catch (err) {
    console.error('Remove line item failed:', err);
  } finally {
    targetRow.classList.remove('line-item-updating');
    btn.style.pointerEvents = '';
  }
}, true);


// Neutralize Instant's native quantity-increment/decrement dispatcher —
// same pattern as href and adjust-line-item-quantity before it.
function neutralizeQtyButton(el) {
  if (el.dataset.qtyBtnPatched) return;
  el.dataset.qtyBtnPatched = 'true';
  el.removeAttribute('data-instant-action-type');
}
function isQtyButton(el) {
  const type = el.getAttribute?.('data-instant-action-type');
  return type === 'quantity-increment' || type === 'quantity-decrement';
}
document.querySelectorAll('[data-instant-action-type="quantity-increment"], [data-instant-action-type="quantity-decrement"]').forEach(neutralizeQtyButton);
new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (m.type === 'attributes' && isQtyButton(m.target)) neutralizeQtyButton(m.target);
    if (m.type === 'childList') {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (isQtyButton(node)) neutralizeQtyButton(node);
        node.querySelectorAll?.('[data-instant-action-type="quantity-increment"], [data-instant-action-type="quantity-decrement"]').forEach(neutralizeQtyButton);
      });
    }
  }
}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-instant-action-type'] });

// Shared handler — delta is +1 for increment, -1 for decrement. Decrementing
// from 1 sends quantity:0, which Shopify's /cart/change.js treats as a
// removal natively, so no special-casing needed for the "remove at qty 1" case.
async function adjustLineItemQuantity(row, delta) {
  const lineItemKey = row.getAttribute('data-instant-form-line-item-key');
  if (!lineItemKey) return;

  const decBtn = row.querySelector('.instant_cart-line-item-decrement');
  const incBtn = row.querySelector('.instant_cart-line-item-increment');
  row.classList.add('line-item-updating');
  if (decBtn) decBtn.style.pointerEvents = 'none';
  if (incBtn) incBtn.style.pointerEvents = 'none';

  try {
    // read current quantity from the server rather than the DOM — avoids any
    // dependency on parsing a quantity display, and guards against acting on
    // a stale number if something else changed the cart moments earlier
    const cart = await fetch('/cart.js').then(r => r.json());
    const item = cart.items.find(i => i.key === lineItemKey);
    if (!item) throw new Error('Line item not found in cart');
    const newQty = Math.max(0, item.quantity + delta);

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineItemKey, quantity: newQty }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || `Quantity update failed: ${res.status}`);
    }
    await window.Instant.api.updateCart();
  } catch (err) {
    console.error('Adjust line item quantity failed:', err);
  } finally {
    row.classList.remove('line-item-updating');
    if (decBtn) decBtn.style.pointerEvents = '';
    if (incBtn) incBtn.style.pointerEvents = '';
  }
}

document.addEventListener('click', function(e) {
  const decBtn = e.target.closest('.instant_cart-line-item-decrement');
  const incBtn = e.target.closest('.instant_cart-line-item-increment');
  const btn = decBtn || incBtn;
  if (!btn) return;

  const row = btn.closest('[data-instant-repeater-type="CART_ITEMS"]');
  if (!row) return;

  adjustLineItemQuantity(row, decBtn ? -1 : 1);
}, true);